// ABOUTME: The ruler glyph next to a workout's distance on the calendar card
// ABOUTME: Drawn in currentColor — its own near-black, the foreground in the dark theme — unless the caller sets one

import type { FC } from "react"
import { cn } from "@shared/lib/utils"

export const DistanceIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={cn("text-[#101010] dark:text-foreground", className)}
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M8.48464 11.0137H7.21191V12.2864H8.48464V11.0137Z"
          fill="currentColor"
        />
        <path
          d="M5.09109 11.0137H3.81836V12.2864H5.09109V11.0137Z"
          fill="currentColor"
        />
        <path
          d="M3.39382 11.0137H2.12109V12.2864H3.39382V11.0137Z"
          fill="currentColor"
        />
        <path
          d="M6.78835 11.0137H5.51562V12.2864H6.78835V11.0137Z"
          fill="currentColor"
        />
        <path
          d="M11.8792 11.0137H10.6064V12.2864H11.8792V11.0137Z"
          fill="currentColor"
        />
        <path
          d="M10.1819 11.0137H8.90918V12.2864H10.1819V11.0137Z"
          fill="currentColor"
        />
        <path
          d="M6.36364 4.8957C6.36364 3.14103 4.93623 1.7135 3.18178 1.7135C1.42732 1.7135 0 3.14103 0 4.8957C0 7.75213 2.71787 9.56156 2.8336 9.6372C2.93936 9.70631 3.06057 9.74089 3.18178 9.74089C3.30298 9.74089 3.42419 9.70631 3.52995 9.6372C3.5451 9.62732 3.90579 9.39008 4.35816 8.9686C5.27308 8.11638 6.36364 6.71799 6.36364 4.8957ZM3.49067 8.03739C3.37816 8.14222 3.27303 8.23288 3.18122 8.30831C2.54762 7.78874 1.27273 6.53892 1.27273 4.8957C1.27273 3.84282 2.1291 2.98623 3.18178 2.98623C4.23445 2.98623 5.09091 3.84282 5.09091 4.8957C5.09091 6.26028 4.2207 7.35732 3.49067 8.03739Z"
          fill="currentColor"
        />
        <path
          d="M3.18149 5.74384C3.6501 5.74384 4.02998 5.36397 4.02998 4.89536C4.02998 4.42675 3.6501 4.04688 3.18149 4.04688C2.71289 4.04688 2.33301 4.42675 2.33301 4.89536C2.33301 5.36397 2.71289 5.74384 3.18149 5.74384Z"
          fill="currentColor"
        />
        <path
          d="M10.8185 1.7135C9.06404 1.7135 7.63672 3.14103 7.63672 4.8957C7.63672 7.75213 10.3546 9.56156 10.4703 9.6372C10.5761 9.70631 10.6973 9.74089 10.8185 9.74089C10.9397 9.74089 11.0609 9.70631 11.1667 9.6372C11.1818 9.62732 11.5425 9.39008 11.9949 8.9686C12.9098 8.11638 14.0004 6.71799 14.0004 4.8957C14.0004 3.14103 12.5729 1.7135 10.8185 1.7135ZM11.1274 8.03739C11.0149 8.14222 10.9097 8.23288 10.8179 8.30831C10.1843 7.78874 8.90945 6.53892 8.90945 4.8957C8.90945 3.84282 9.76582 2.98623 10.8185 2.98623C11.8712 2.98623 12.7276 3.84282 12.7276 4.8957C12.7276 6.26028 11.8574 7.35732 11.1274 8.03739Z"
          fill="currentColor"
        />
        <path
          d="M10.8182 5.74384C11.2868 5.74384 11.6667 5.36397 11.6667 4.89536C11.6667 4.42675 11.2868 4.04688 10.8182 4.04688C10.3496 4.04688 9.96973 4.42675 9.96973 4.89536C9.96973 5.36397 10.3496 5.74384 10.8182 5.74384Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
